
































import { Component, Vue } from 'vue-property-decorator';
// import AccountModalBase from '@/parts/account/AccountModalBase.vue';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/app';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';
import util from '@/components/util';


export default Vue.extend({
  name: 'ChangeModal',
  components: {
    // AccountModalBase,
    VariableInput ,
  },
  data() {
    return {
      showModal: false,
      accountData: new models.CAuth(),
      items: [
        {key: 'mail', name: 'メールアドレス', type: vi.INPUT_TYPE.TEXT, placeholder: 'sample@rimolabo.com', required: true, checks: [vi.CHECK_TYPE.EMAIL], error: '', max: 40 },
        {key: 'password', name: 'パスワード', type: vi.INPUT_TYPE.PASSWORD, placeholder: 'パスワード', required: true, checks: [vi.CHECK_TYPE.PASSWORD], notice: '半角大小文字英数字を1文字ずつ含む8文字以上', error: '', max: 40 },
        // {key: 'passwordConfirm', name: 'パスワード(確認用)', type: vi.INPUT_TYPE.PASSWORD, placeholder: '半角大小英数字を1文字ずつ含む8文字以上', required: true, checks: [vi.CHECK_TYPE.PASSWORD], error: '', max: 40 },
      ] as vi.IVariableInput[],
      dispToggleInputs: [
        'password',
      ],
      dispToggles: {
        password: 'password',
      },
    };
  },
  methods: {
    dispToggle(input: string) {
      const el = document.querySelector('#' + input + '-input input') as any;

      if (el.type === 'text') {
        el.type = 'password';
      } else {
        el.type = 'text';
      }
    },
    onClickChange() {
      // vallidation check
      if (vi.checkValues(this.accountData, this.items) > 0) {
        return;
      }
      // // パスワードが確認と一致しない場合
      // if (this.accountData.password !== this.accountData.passwordConfirm) {
      //   this.items[2].error = 'パスワードが一致しません';
      //   return;
      // }
      this.$emit('change', this.accountData);
    },
  },
});
